import clsx from 'clsx'
import React, { FC, ReactNode, useEffect, useRef, useState } from 'react'

import SvgInfo from '@Assets/SVG/Info'

import styles from './UpSellTooltip.module.scss'

type UpSellTooltipProps = {
  children: ReactNode
  className?: string
}

export const UpSellTooltip: FC<UpSellTooltipProps> = ({
  children,
  className,
}) => {
  const [open, setOpen] = useState(false)

  const tooltipRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const closeTooltip = (e: MouseEvent) => {
      if (!tooltipRef.current?.contains(e.target as Node) && open) {
        setOpen(false)
      }
    }

    document.addEventListener('click', closeTooltip)

    return () => {
      document.removeEventListener('click', closeTooltip)
    }
  }, [open])

  return (
    <div className={clsx(styles.tooltip, className)} ref={tooltipRef}>
      <button
        aria-label="Open"
        className={`${styles.trigger} ${open ? styles.open : ''}`}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          setOpen(!open)
        }}
        type="button"
      >
        <SvgInfo />
      </button>

      <div className={`${styles.content} ${open ? styles.open : ''}`}>
        {children}
      </div>
    </div>
  )
}
